"use client"
import { tv } from "@opensea/ui-kit"

export const bottomFixedVariants = tv({
  base: "lg:!bottom-page-footer fixed bottom-0",
})
